import ApplicationController from "../application_controller";
import DataTable from 'datatables.net-dt';
import 'datatables.net-buttons-dt';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import JSZip from 'jszip';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

// Set up PDF fonts
pdfMake.vfs = pdfFonts.pdfMake.vfs;
window.JSZip = JSZip;


// Then use the fonts by their filename
pdfMake.fonts = {
  OpenSansHebrew: {
    normal: window.Fonts.openSansHebrew,
    bold: window.Fonts.openSansHebrewBold,
    italic: window.Fonts.openSansHebrewItalic,
    bolditalic: window.Fonts.openSansHebrewBoldItalic
  }
};

export default class extends ApplicationController {
  static targets = ["tableWrapper", "table", "tableBar"];
  static values = { showExport: Boolean, locale: String }

  connect() {
    super.connect();
    
    setTimeout(() => {
      this.initializeDataTable();
      this.enhanceButtonInteractions();
    }, 500);
  }

  initializeDataTable() {
    const tableElement = this.tableTarget;
    const that = this; // Store reference to controller
    
    try {
      // Process select elements to show only selected values
      this.prepareSelectElementsForExport(tableElement);
      
      // Check if the table should show all entries
      const showAllEntries = tableElement.hasAttribute('data-show-all-entries');
      
      // Get the current locale from Stimulus values
      const currentLocale = this.localeValue || 'he';
      
      console.log('Current locale:', currentLocale); // Debug log
      console.log('Show export:', this.showExportValue); // Debug log
      
      // Determine which buttons to show based on locale and showExport value
      let buttons = [];
      if (this.showExportValue) {
        buttons = [
          {
            extend: 'csv',
            text: '<i class="material-icons">description</i> CSV',
            className: 'buttons-csv',
            exportOptions: {
              columns: ':visible',
              format: {
                body: function (data) {
                  return that.strip_html_only_elements_and_html_tags(data);
                }
              }
            }
          }, 
          {
            extend: 'excelHtml5',
            text: '<i class="material-icons">table_chart</i> Excel',
            className: 'buttons-excel',
            exportOptions: {
              columns: ':visible',
              format: {
                body: function (data) {
                  return that.strip_html_only_elements_and_html_tags(data);
                }
              },
              customizeData: function (data) {
                that.stripNoDataColumns(data);
              }
            },
          }
        ];

        // Only add PDF button if locale is Hebrew
        if (currentLocale === 'he') {
          console.log('Adding PDF button for Hebrew locale'); // Debug log
          buttons.push({
            extend: 'pdfHtml5',
            text: '<i class="material-icons">picture_as_pdf</i> PDF',
            className: 'buttons-pdf',
            orientation: 'landscape',
            charset: 'utf-8',
            filename: function() {
              // Check if this is a cleaning report
              const isCleaningReport = document.querySelector('input[data-vacancies-target="date"]') || 
                                     document.querySelector('.cleaning-section') ||
                                     window.location.pathname.includes('cleaning') ||
                                     document.title.includes('ניקיון');
              
              if (isCleaningReport) {
                const dateInput = document.querySelector('input[data-vacancies-target="date"]') || 
                                document.querySelector('input[type="date"]');
                const cleaningDate = dateInput ? new Date(dateInput.value) : new Date();
                const hebrewDays = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
                const dayName = hebrewDays[cleaningDate.getDay()];
                const dateStr = cleaningDate.toISOString().split('T')[0];
                return `cleaning_report_${dayName}_${dateStr}`;
              }
              
              return 'report';
            },
            exportOptions: {
              columns: function(idx, data, node) {
                // Skip columns with action buttons or that have the class 'no-export'
                const headerText = $(node).text().trim().toLowerCase();
                return !$(node).hasClass('no-export') && 
                       headerText !== 'action' && 
                       headerText !== 'actions' && 
                       headerText !== 'פעולות' && 
                       !$(node).hasClass('actions-column');
              },
              format: {
                body: function (data) {
                  return that.strip_html_only_elements_and_html_tags(data);
                }
              },
              customizeData: function(data) {
                that.stripNoDataColumns(data);
                
                // Additional check to remove any problematic cells
                if (data && data.body) {
                  data.body.forEach(function(row) {
                    for (let i = 0; i < row.length; i++) {
                      if (row[i] === undefined || row[i] === null) {
                        row[i] = ''; // Replace undefined/null with empty string
                      }
                    }
                  });
                }
              }
            },
            customize: function(doc) {
              doc.defaultStyle.font = 'OpenSansHebrew';
              doc.defaultStyle.direction = 'rtl';
              doc.defaultStyle.alignment = 'right';

              // Check if this is a cleaning report by looking for cleaning-related content
              const isCleaningReport = document.querySelector('input[data-vacancies-target="date"]') || 
                                     document.querySelector('.cleaning-section') ||
                                     window.location.pathname.includes('cleaning') ||
                                     document.title.includes('ניקיון');

              let titleText = "הגבעה";
              let fileName = "report";

              if (isCleaningReport) {
                // Get cleaning date from the date input or current date
                const dateInput = document.querySelector('input[data-vacancies-target="date"]') || 
                                document.querySelector('input[type="date"]');
                const cleaningDate = dateInput ? new Date(dateInput.value) : new Date();
                
                // Hebrew day names
                const hebrewDays = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
                const dayName = hebrewDays[cleaningDate.getDay()];
                const dateStr = cleaningDate.toLocaleDateString('he-IL');
                
                titleText = `דוח  ניקיון - יום ${dayName} ${dateStr}`;
                fileName = `cleaning_report_${cleaningDate.toISOString().split('T')[0]}`;
              }

              if (doc.content[0] && typeof doc.content[0] === 'object') {
                doc.content[0].font = 'OpenSansHebrew';
                doc.content[0].alignment = 'right';
                doc.content[0].rtl = true;
                doc.content[0].text = titleText;
              
                // OPTIONAL: force bidi-friendly rendering by reversing words
                if (typeof doc.content[0].text === 'string' && /[\u0590-\u05FF]/.test(doc.content[0].text)) {
                  const words = doc.content[0].text.split(' ');
                  doc.content[0].text = words.reverse().join(' ');
                }
              }

              // Set the filename for download
              if (isCleaningReport) {
                doc.info = doc.info || {};
                doc.info.title = fileName;
              }

              doc.content[1].table.body.forEach(function (row) {
                row.reverse();
              });

              // Set page margins and styles
              doc.pageMargins = [40, 60, 40, 60];
              doc.styles.tableHeader.fontSize = 10;
              doc.styles.tableFooter.fontSize = 10;
              doc.styles.title.fontSize = 14;
              
              // Use the Hebrew font - call the method from the controller
              that.customHebrewFix(doc);

              $(window.document.body).css('direction', 'rtl');
              $(window.document.body).css('text-align','right');

              // Set the table to RTL
              if (doc.content[1] && doc.content[1].table) {
                // Set column widths
                doc.content[1].table.widths = Array(doc.content[1].table.body[0].length).fill('*');

                // Safely iterate through all table cells
                doc.content[1].table.body.forEach(row => {
                  if (Array.isArray(row)) {
                    row.forEach(cell => {
                      // Only apply style if cell is an object, not a string or other primitive
                      if (cell && typeof cell === 'object') {
                        // Create style object if it doesn't exist
                        if (!cell.style) cell.style = {};
                        // Set RTL properties
                        cell.rtl = true;
                        cell.alignment = 'right';
                        cell.font = 'OpenSansHebrew';
                      }
                    });
                  }
                });
              }
            }
          });
        } else {
          console.log('Skipping PDF button for locale:', currentLocale); // Debug log
        }

        buttons.push({
          extend: 'print',
          text: '<i class="material-icons">print</i> הדפסה',
          className: 'buttons-print',
          exportOptions: {
            columns: ':visible',
            format: {
              body: function (data) {
                return that.strip_html_only_elements_and_html_tags(data);
              }
            }
          }
        });
      }
      
      console.log('Final buttons array:', buttons); // Debug log
      
      // Create DataTable configuration
      const dataTableConfig = {
        dom: showAllEntries ? 
          '<"datatable-top"Bf>rt<"datatable-bottom"ip>' : // No length menu if show all
          '<"datatable-top"Bf>rt<"datatable-bottom"lip>', // Default with length menu
        paging: !showAllEntries, // Disable pagination if show all
        lengthChange: !showAllEntries, // Disable length changing if show all
        buttons: buttons,
        language: {
          search: "חיפוש:",
          lengthMenu: "הצג _MENU_ שורות",
          info: showAllEntries ? 
            "מציג את כל הרשומות (_TOTAL_ סה״כ)" : // Modified info text for show all
            "מציג _START_ עד _END_ מתוך _TOTAL_ רשומות", // Default info text
          infoEmpty: "מציג 0 עד 0 מתוך 0 רשומות",
          infoFiltered: "(מסונן מתוך _MAX_ רשומות)",
          paginate: {
            first: "ראשון",
            last: "אחרון",
            next: "הבא",
            previous: "הקודם"
          }
        }
      };
      
      // Initialize DataTable with configuration
      this.dataTable = new DataTable(tableElement, dataTableConfig);
      
      // Add custom class to search input
      const searchInput = document.querySelector('.dataTables_filter input');
      if (searchInput) {
        searchInput.classList.add('search-input');
        searchInput.setAttribute('placeholder', 'חיפוש...');
      }
      
      window.dataTables = window.dataTables || {};
      window.dataTables[this.element.id] = this.dataTable;
    } catch (error) {
      console.error("Error initializing DataTable:", error);
    }
  }

  prepareSelectElementsForExport(tableElement) {
    // Add data attributes to select elements to help with export
    const selects = tableElement.querySelectorAll('select');
    selects.forEach(select => {
      select.setAttribute('data-export-text', select.options[select.selectedIndex]?.text || '');
      
      // Update the data attribute when the select value changes
      select.addEventListener('change', () => {
        select.setAttribute('data-export-text', select.options[select.selectedIndex]?.text || '');
      });
    });
  }

  search(event) {
    if (this.dataTable) {
      this.dataTable.search(event.target.value).draw();
    }
  }

  toggleFullscreen() {
    this.element.classList.toggle('fullscreen');
    if (this.dataTable) {
      this.dataTable.columns.adjust().draw();
    }
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable.destroy();
    }
  }

  customHebrewFix(doc) {
    if (!doc.content[1] || !doc.content[1].table || !doc.content[1].table.body) {
      console.warn('PDF document structure is not as expected');
      return;
    }

    var columns = doc.content[1].table.body[0].length;

    // Iterate over each row in the PDF content
    for (var i = 0; i < doc.content[1].table.body.length; i++) {
      var row = doc.content[1].table.body[i];

      // Iterate over each cell in the row
      for (var j = 0; j < columns; j++) {
        var cell = row[j];
        
        // Skip if cell is null or undefined
        if (!cell) continue;

        // Ensure cell is an object with a text property
        if (typeof cell === 'string') {
          cell = row[j] = { text: cell };
        }

        // Handle Hebrew text
        if (cell.text && typeof cell.text === "string" && /[^\u0000-\u00FF]/.test(cell.text)) {
          cell.text = cell.text.split(" ").reverse().join("  ");
          cell.alignment = "right";
          cell.rtl = true;
          cell.font = "OpenSansHebrew";
        }
      }
    }
  }

  decodeHtmlEntities(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }

  strip_html_only_elements_and_html_tags(data) {
    // Handle select elements
    if (data.includes('<select')) {
      const divElement = document.createElement("div");
      divElement.innerHTML = data;
      const selectElement = divElement.querySelector('select');
      if (selectElement && selectElement.hasAttribute('data-export-text')) {
        return selectElement.getAttribute('data-export-text');
      }
    }
    
    // Handle SVG icons - check for green checkmark or red X
    if (data.includes('<svg')) {
      if (data.includes('fill="#2DC214"')) {
        return 'כן';
      } else if (data.includes('fill="#CE1515"')) {
        return 'לא';
      }
    }
    
    // Handle time input fields specifically
    if (data.includes('type="time"') || data.includes('class="edit-time"')) {
      const divElement = document.createElement("div");
      divElement.innerHTML = data;
      const timeInput = divElement.querySelector('input[type="time"]');
      if (timeInput && timeInput.value) {
        return timeInput.value;
      }
      return '';
    }
    
    // Handle action buttons - return empty string to hide them
    if (data.includes('class="btn') || data.includes('button')) {
      return '';
    }
    
    // Handle checkboxes
    if (data.startsWith('<input type="checkbox"')) {
      if (data.includes('value="1"')) {
        return "כן";
      } else if (data.includes('value=""')) {
        return "לא";
      }
    }
    
    // Handle input elements (but not time inputs - those are handled above)
    if (data.startsWith("<input") && !data.includes('type="time"')) {
      const extract_value = this.extractInputValue(data);
      if (extract_value != data) {
        return extract_value;
      }
    }
    
    // Handle HTML elements
    if (data.includes("html_only") || /<[a-z][\s\S]*>/i.test(data)) {
      // Create a DOM element from the HTML string
      const divElement = document.createElement("div");
      divElement.innerHTML = data;
      
      // Remove html_only elements
      $(divElement).find(".html_only").remove();
      
      // Remove mobile-only elements that shouldn't appear in exports
      $(divElement).find(".mobile-only").remove();
      
      // Remove desktop-only elements on mobile (though this is less relevant for exports)
      // $(divElement).find(".desktop-only").remove();
      
      const cleanText = divElement.textContent.trim();
      data = cleanText;
    }
    
    data = this.decodeHtmlEntities(data);
    return data;
  }

  extractInputValue(str) {
    const regex = /<input.*?value="(.*?)".*?>/i;
    const match = str.match(regex);
    if (match && match[1]) {
      return match[1];
    } else {
      return str;
    }
  }  

  stripNoDataColumns(data) {
    // Create arrays of indices to remove
    const columnsToRemove = ["Action", "Actions", "פעולות"].map(header => 
      data.header.indexOf(header)
    ).filter(index => index > -1);

    if (columnsToRemove.length > 0) {
      // Sort indices in descending order to remove from right to left
      columnsToRemove.sort((a, b) => b - a);

      // Remove columns from header
      columnsToRemove.forEach(index => {
        data.header.splice(index, 1);
      });

      // Remove columns from body
      data.body = data.body.map(row => {
        columnsToRemove.forEach(index => {
          row.splice(index, 1);
        });
        return row;
      });
    }

    // Fix: Don't convert cells to objects here - this is causing [object Object] to appear
    // Instead, ensure all cells are strings
    data.body = data.body.map(row => 
      row.map(cell => {
        // If cell is null/undefined, return empty string
        if (cell == null) return '';
        
        // If cell is already an object with text property, extract the text
        if (typeof cell === 'object' && cell.text) return cell.text;
        
        // Convert cell to string
        return String(cell);
      })
    );

    return data;
  }

  enhanceButtonInteractions() {
    // Add hover tooltip to buttons
    const buttons = document.querySelectorAll('.dt-button');
    buttons.forEach(button => {
      button.addEventListener('mouseenter', function() {
        this.style.transform = 'translateY(-2px)';
      });
      
      button.addEventListener('mouseleave', function() {
        this.style.transform = 'translateY(0)';
      });
    });
  }
} 